<div class="section">
  <ion-header no-border class="header-container"
              [ngClass]="{'animation': isDesktop}">
    <pptl-header-delivery-view *ngIf="isLogined$ | async; else showAnonymousBlock"></pptl-header-delivery-view>
    <ng-template #showAnonymousBlock>
      <pptl-header-anonymous></pptl-header-anonymous>
    </ng-template>
  </ion-header>
  <div class="main-container">
    <router-outlet></router-outlet>
  </div>
</div>
